import { PageContent } from '@va/dashboard/shared/ui-layout';
import LatestVisitorsMap from './LatestVisitorsMap';

export const MapTab = () => {
  return (
    <PageContent>
      <LatestVisitorsMap />
    </PageContent>
  );
};
